"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetXtoken = void 0;

var http_1 = require("@xbox/http");

var Constants_1 = require("../../Constants");

var XalInternalError_1 = require("../../errors/XalInternalError");

var XalInternalErrorType_1 = require("../../errors/XalInternalErrorType");

var ITelemetryClient_1 = require("../../ITelemetryClient");

var RequestSigner_1 = require("../../RequestSigner");

var Utils_1 = require("../../Utils");

var XboxToken_1 = require("../../XboxToken");

var OperationBase_1 = require("../OperationBase");

var SisuEndUri_1 = require("../SisuEndUri");

var StepTracker_1 = require("../StepTracker");

var AuthorizeWithSisu_1 = require("../xboxToken/AuthorizeWithSisu");

var RefreshXtoken_1 = require("../xboxToken/RefreshXtoken");

var GetDtoken_1 = require("./GetDtoken");

var GetMsaTicket_1 = require("./GetMsaTicket");

var InitializeTokenStack_1 = require("./InitializeTokenStack");

var framework_1 = require("@xbox/framework");

var Step;

(function (Step) {
  Step["Start"] = "Start";
  Step["Init"] = "Init";
  Step["GetDtoken"] = "GetDtoken";
  Step["AuthenticateWithMsa"] = "AuthenticateWithMsa";
  Step["GetSisuTokens"] = "GetSisuTokens";
  Step["ShowSisuUi"] = "ShowSisuUi";
  Step["RefreshXtoken"] = "RefreshXtoken";
  Step["LoadTitleNsal"] = "LoadTitleNsal";
  Step["Done"] = "Done";
})(Step || (Step = {}));

var GetXtoken =
/** @class */
function (_super) {
  __extends(GetXtoken, _super);

  function GetXtoken(telemetryClient, tokenStackComponents, webView, msaUserId, forceRefresh, forceCallSisu, httpClient, xtoken, callingOperation, msaTicket, sisuSessionId, sisuClusterAffinity, responseUrl, rehydrationParams) {
    if (callingOperation === void 0) {
      callingOperation = undefined;
    }

    if (msaTicket === void 0) {
      msaTicket = undefined;
    }

    if (sisuSessionId === void 0) {
      sisuSessionId = undefined;
    }

    if (sisuClusterAffinity === void 0) {
      sisuClusterAffinity = undefined;
    }

    if (responseUrl === void 0) {
      responseUrl = undefined;
    }

    if (rehydrationParams === void 0) {
      rehydrationParams = undefined;
    }

    var _this = _super.call(this, telemetryClient) || this;

    _this.tokenStackComponents = tokenStackComponents;
    _this.webView = webView;
    _this.msaUserId = msaUserId;
    _this.forceRefresh = forceRefresh;
    _this.forceCallSisu = forceCallSisu;
    _this.httpClient = httpClient;
    _this.xtoken = xtoken;
    _this.callingOperation = callingOperation;
    _this.msaTicket = msaTicket;
    _this.sisuSessionId = sisuSessionId;
    _this.sisuClusterAffinity = sisuClusterAffinity;
    _this.responseUrl = responseUrl;
    _this.rehydrationParams = rehydrationParams;
    _this.step = new StepTracker_1.StepTracker(ITelemetryClient_1.Area.GetXtoken, Step.Start);
    _this.xtokenRefreshRetries = 0;
    _this.refreshingConstituentTokens = false;
    _this.forceRefreshDtoken = false;
    _this.forceRefreshMsaTicket = false;
    Utils_1.assert(!Utils_1.isNullOrWhiteSpace(msaUserId));
    Utils_1.assert(!!_this.xtoken);
    return _this;
  }

  GetXtoken.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operation;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            Utils_1.assert(this.step.currentStep === Step.Start);
            this.step.advance(Step.Init);
            operation = new InitializeTokenStack_1.InitializeTokenStack(this.telemetryClient, this.tokenStackComponents, this.httpClient, false // offlineMode
            );
            operation.execute();
            return [4
            /*yield*/
            , operation.completionPromise];

          case 1:
            _a.sent();

            Utils_1.assert(this.step.currentStep === Step.Init);

            if (!Utils_1.isNullOrWhiteSpace(this.responseUrl)) {
              this.restoreRehydrationParams();
            }

            if (!(!this.forceCallSisu && !this.forceRefresh && this.xtoken.isValid)) return [3
            /*break*/
            , 3]; // We still need to make sure title NSAL is loaded

            return [4
            /*yield*/
            , this.loadTitleNsal()];

          case 2:
            // We still need to make sure title NSAL is loaded
            _a.sent();

            return [2
            /*return*/
            ];

          case 3:
            // Our current xtoken is either missing or not present so now we have to
            // start getting all the constituent tokens.
            return [4
            /*yield*/
            , this.getDtoken()];

          case 4:
            // Our current xtoken is either missing or not present so now we have to
            // start getting all the constituent tokens.
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.getDtoken = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operation, dtoken;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.step.advance(Step.GetDtoken);
            operation = new GetDtoken_1.GetDtoken(this.telemetryClient, this.tokenStackComponents, this.httpClient, this.forceRefreshDtoken);
            operation.execute();
            return [4
            /*yield*/
            , operation.completionPromise];

          case 1:
            dtoken = _a.sent();
            Utils_1.assert(this.step.currentStep === Step.GetDtoken);
            this.dtoken = dtoken;
            this.forceRefreshDtoken = false;
            return [4
            /*yield*/
            , this.authenticateWithMsa()];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.authenticateWithMsa = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operation, ticketData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(this.forceRefreshMsaTicket || !this.msaTicket)) return [3
            /*break*/
            , 3];
            this.step.advance(Step.AuthenticateWithMsa);
            operation = new GetMsaTicket_1.GetMsaTicket(this.telemetryClient, this.tokenStackComponents.config.userSignInScopes, this.forceRefreshMsaTicket, true, // skipSplash
            this.tokenStackComponents, this.httpClient, this.webView, "MsaInterrupt", // callingOperation
            this.msaUserId);
            operation.execute();
            return [4
            /*yield*/
            , operation.completionPromise];

          case 1:
            ticketData = _a.sent();
            Utils_1.assert(this.step.currentStep === Step.AuthenticateWithMsa);
            this.forceRefreshMsaTicket = false;
            Utils_1.assert(this.msaUserId === ticketData.msaUser.userId);
            this.sisuClusterAffinity = ticketData.sisuClusterAffinity;
            this.sisuSessionId = ticketData.sisuSessionId;
            this.msaTicket = ticketData.ticket;
            return [4
            /*yield*/
            , this.getSisuTokens()];

          case 2:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 3:
            Utils_1.assert(!Utils_1.isNullOrWhiteSpace(this.msaTicket.ticket));
            return [4
            /*yield*/
            , this.getSisuTokens()];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.getSisuTokens = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operation, data, error_1, xalError;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.utoken) {
              this.utoken = this.tokenStackComponents.xboxCache.getToken(XboxToken_1.IdentityType.Utoken, this.tokenStackComponents.config.xboxLiveRelyingParty, "", // subRelyingParty
              "JWT", false, // hasSignInDisplayClaims
              this.msaUserId);
            }

            if (!this.ttoken) {
              this.ttoken = this.tokenStackComponents.xboxCache.getToken(XboxToken_1.IdentityType.Ttoken, this.tokenStackComponents.config.xboxLiveRelyingParty, "", // subRelyingParty
              "JWT");
            }

            Utils_1.assert(!!this.ttoken);
            Utils_1.assert(!!this.utoken);
            Utils_1.assert(!!this.msaTicket && !Utils_1.isNullOrWhiteSpace(this.msaTicket.ticket));
            if (!!Utils_1.isNullOrWhiteSpace(this.responseUrl)) return [3
            /*break*/
            , 2]; // App rehydrated while showing SISU, directly handle response url

            return [4
            /*yield*/
            , this.handleSisuResponse(this.responseUrl)];

          case 1:
            // App rehydrated while showing SISU, directly handle response url
            _a.sent();

            this.responseUrl = undefined;
            return [3
            /*break*/
            , 14];

          case 2:
            if (!(this.forceCallSisu || !this.ttoken.isValid || !this.utoken.isValid)) return [3
            /*break*/
            , 13];
            this.step.advance(Step.GetSisuTokens);
            operation = new AuthorizeWithSisu_1.AuthorizeWithSisu(this.telemetryClient, this.tokenStackComponents, this.httpClient, this.dtoken, this.ttoken, this.utoken, this.xtoken, this.msaUserId, this.msaTicket.ticket, this.sisuSessionId, this.sisuClusterAffinity);
            operation.execute();
            data = void 0;
            _a.label = 3;

          case 3:
            _a.trys.push([3, 5,, 8]);

            return [4
            /*yield*/
            , operation.completionPromise];

          case 4:
            data = _a.sent();
            return [3
            /*break*/
            , 8];

          case 5:
            error_1 = _a.sent();
            xalError = error_1;
            if (!(xalError && xalError.errorType && xalError.errorType === XalInternalErrorType_1.XalInternalErrorType.BadUserToken)) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this.refreshConstituentTokensAndRestart()];

          case 6:
            _a.sent();

            return [2
            /*return*/
            ];

          case 7:
            this.step.advance(Step.Done);
            this.fail(error_1);
            return [2
            /*return*/
            ];

          case 8:
            Utils_1.assert(data.utoken === this.utoken);
            Utils_1.assert(data.ttoken === this.ttoken);
            Utils_1.assert(data.xtoken === this.xtoken);
            this.sisuSessionId = data.sessionId;
            this.sisuClusterAffinity = data.clusterAffinity;
            if (!data.xtoken.isValid) return [3
            /*break*/
            , 10];
            this.sisuUrl = data.pageUrl;
            return [4
            /*yield*/
            , this.loadTitleNsal()];

          case 9:
            _a.sent();

            return [3
            /*break*/
            , 12];

          case 10:
            return [4
            /*yield*/
            , this.showSisuUi(data.pageUrl)];

          case 11:
            _a.sent();

            _a.label = 12;

          case 12:
            return [3
            /*break*/
            , 14];

          case 13:
            this.refreshXtoken();
            _a.label = 14;

          case 14:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.refreshXtoken = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operation, result, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.step.advance(Step.RefreshXtoken);
            Utils_1.assert(!!this.xtoken);
            Utils_1.assert(this.forceRefresh || !this.xtoken.isValid);
            operation = new RefreshXtoken_1.RefreshXtoken(this.telemetryClient, this.tokenStackComponents, this.httpClient, this.dtoken, this.ttoken, this.utoken, this.xtoken);
            operation.execute();
            return [4
            /*yield*/
            , operation.completionPromise];

          case 1:
            result = _b.sent();
            Utils_1.assert(this.step.currentStep === Step.RefreshXtoken);
            Utils_1.assert(result === this.xtoken);
            if (!(this.xtoken.xerr !== 0)) return [3
            /*break*/
            , 8];
            Utils_1.assert(!this.xtoken.isValid);
            _a = this.xtoken.xerr;

            switch (_a) {
              case Constants_1.Xerr.ExpiredDtoken:
                return [3
                /*break*/
                , 2];

              case Constants_1.Xerr.InvalidDtoken:
                return [3
                /*break*/
                , 2];

              case Constants_1.Xerr.ExpiredUtoken:
                return [3
                /*break*/
                , 2];

              case Constants_1.Xerr.InvalidUtoken:
                return [3
                /*break*/
                , 2];

              case Constants_1.Xerr.ExpiredTtoken:
                return [3
                /*break*/
                , 2];

              case Constants_1.Xerr.InvalidTtoken:
                return [3
                /*break*/
                , 2];
            }

            return [3
            /*break*/
            , 4];

          case 2:
            return [4
            /*yield*/
            , this.refreshConstituentTokensAndRestart()];

          case 3:
            _b.sent();

            return [3
            /*break*/
            , 5];

          case 4:
            return [3
            /*break*/
            , 5];

          case 5:
            if (!(this.xtokenRefreshRetries > 2)) return [3
            /*break*/
            , 6];
            Utils_1.xalTrace(Utils_1.TraceLevel.Error, "XSTS returned with Xerr, maximum number of retries exceeded");
            this.step.advance(Step.Done);
            this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "XSTS returned with Xerr, maximum number of retries exceeded"));
            return [2
            /*return*/
            ];

          case 6:
            this.xtokenRefreshRetries++;
            Utils_1.xalTrace(Utils_1.TraceLevel.Important, "XSTS returned with Xerr, invoking SISU. Attempt " + this.xtokenRefreshRetries);
            this.forceCallSisu = true;
            return [4
            /*yield*/
            , this.getSisuTokens()];

          case 7:
            _b.sent();

            return [2
            /*return*/
            ];

          case 8:
            return [4
            /*yield*/
            , this.loadTitleNsal()];

          case 9:
            _b.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.refreshConstituentTokensAndRestart = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            Utils_1.assert(this.xtoken.xerr !== 0);
            this.telemetryClient.instrumentAppError(ITelemetryClient_1.Area.GetXtoken, "Invalid user credentials error received", this.refreshingConstituentTokens ? ITelemetryClient_1.ErrorLevel.Error : ITelemetryClient_1.ErrorLevel.Warning, XalInternalErrorType_1.XalInternalErrorType.BadUserToken);

            if (this.refreshingConstituentTokens) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Error, "Xtoken operation received bad token errors twice in a row. Failing out.");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "Xtoken operation received bad token errors twice in a row. Failing out."));
              return [2
              /*return*/
              ];
            } else {
              Utils_1.xalTrace(Utils_1.TraceLevel.Important, "Xtoken operation received bad token error. Retrying with fresh tokens.");
            } // Set a flag so we only restart like this once


            this.refreshingConstituentTokens = true;
            this.forceRefreshDtoken = true;
            this.forceRefreshMsaTicket = true;
            this.forceCallSisu = true; // Restart at step 1

            return [4
            /*yield*/
            , this.getDtoken()];

          case 1:
            // Restart at step 1
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.showSisuUi = function (sisuUrl) {
    return __awaiter(this, void 0, void 0, function () {
      var uri, query, sisuUriForNsal, sisuNsalEntry, signature, action, webViewFlowId, queryString, rehydrationParams, webViewResult, error_2, xalError;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (Utils_1.isNullOrWhiteSpace(sisuUrl)) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Error, "Get Xtoken operation received empty URL.");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "Get Xtoken operation received empty URL."));
              return [2
              /*return*/
              ];
            }

            try {
              uri = new http_1.Url(sisuUrl);
            } catch (error) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Error, "Get Xtoken operation received invalid URL.");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "Get Xtoken operation received invalid URL."));
              return [2
              /*return*/
              ];
            }

            if (!this.webView) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Important, "Operation needed to show UI but was not provided a web view.");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.UiRequired, "Operation needed to show UI but was not provided a web view."));
              return [2
              /*return*/
              ];
            }

            query = Utils_1.parseQuery(uri.search);
            sisuUriForNsal = this.tokenStackComponents.config.sisuEndpoint;
            sisuNsalEntry = this.tokenStackComponents.nsal.lookup(sisuUriForNsal);
            if (!sisuNsalEntry.Policy) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , RequestSigner_1.RequestSigner.signRequest(this.tokenStackComponents.xboxCache.deviceIdentity.key, sisuNsalEntry.Policy, http_1.Http.HttpRequestMethod.Post, "/proxy?sessionid=" + this.sisuSessionId)];

          case 1:
            signature = _a.sent();
            query.set("sig", signature);
            return [3
            /*break*/
            , 3];

          case 2:
            Utils_1.xalTrace(Utils_1.TraceLevel.Information, "NSAL indicates not signing SISU web request.");
            _a.label = 3;

          case 3:
            action = query.get("action");

            if (!action) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Information, "Xtoken operation received SISU veto URL without an action.");
              this.telemetryClient.instrumentAppAction(ITelemetryClient_1.Area.GetXtoken, ITelemetryClient_1.EventAction.SisuWebVeto);
            } else {
              Utils_1.xalTrace(Utils_1.TraceLevel.Information, "Xtoken operation received SISU veto URL with action " + action + ".");
              this.telemetryClient.instrumentAppAction(ITelemetryClient_1.Area.GetXtoken, ITelemetryClient_1.EventAction.SisuWebVeto);
            } // Attach the device id to the query as we're in a veto state that
            // may require it.


            Utils_1.assert(!!this.dtoken && this.dtoken.isValid);
            query.set("did", "0x" + this.dtoken.tokenData.deviceId);
            query.set("sid", this.sisuSessionId);

            if (this.tokenStackComponents.config.sisuRedirectUri) {
              // NOXAL:WEB This allows web clients to redirect to themselves after SISU
              query.set("redirect", this.tokenStackComponents.config.sisuRedirectUri);
            }

            webViewFlowId = framework_1.guid();
            query.set("state", webViewFlowId);
            queryString = Utils_1.createQuery(query);
            uri.search = queryString;
            rehydrationParams = new Map();

            if (this.callingOperation) {
              rehydrationParams.set("operation", this.callingOperation);
            }

            if (this.sisuSessionId) {
              rehydrationParams.set("sisuSessionId", this.sisuSessionId);
            }

            if (this.sisuClusterAffinity) {
              rehydrationParams.set("sisuClusterAffinity", this.sisuClusterAffinity);
            }

            rehydrationParams.set("msaUserId", this.msaUserId);
            this.step.advance(Step.ShowSisuUi);
            _a.label = 4;

          case 4:
            _a.trys.push([4, 6,, 7]);

            return [4
            /*yield*/
            , this.webView.showUrl(uri.toString(), Constants_1.SisuDesktopUri, false, // suppressUi
            webViewFlowId, rehydrationParams)];

          case 5:
            webViewResult = _a.sent();
            return [3
            /*break*/
            , 7];

          case 6:
            error_2 = _a.sent();
            xalError = error_2;

            if (xalError && xalError.errorType && xalError.errorType === XalInternalErrorType_1.XalInternalErrorType.Aborted) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Information, "Veto web view was manually closed by either user or client.");
              this.telemetryClient.instrumentAppAction(ITelemetryClient_1.Area.GetXtoken, ITelemetryClient_1.EventAction.VetoResolutionCanceled);
            }

            this.step.advance(Step.Done);
            this.fail(error_2);
            return [2
            /*return*/
            ];

          case 7:
            return [4
            /*yield*/
            , this.handleSisuResponse(webViewResult)];

          case 8:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.handleSisuResponse = function (responseUrl) {
    return __awaiter(this, void 0, void 0, function () {
      var endUrl, sisuStatus;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            try {
              if (Utils_1.isNullOrWhiteSpace(responseUrl)) {
                throw new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.InvalidArguments, "SISU sign in end URI is invalid.");
              }

              endUrl = new SisuEndUri_1.SisuEndUri(responseUrl);
            } catch (error) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Error, "Veto web view received invalid SISU end URL.");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.InvalidArguments, "Veto web view received invalid SISU end URL."));
              return [2
              /*return*/
              ];
            }

            if (!Utils_1.isNullOrWhiteSpace(endUrl.logMessage)) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Information, "Veto web view passed back log data: " + endUrl.logMessage);
            }

            sisuStatus = endUrl.result;

            if (sisuStatus) {
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(sisuStatus, "SISU end URL contained an error"));
              return [2
              /*return*/
              ];
            }

            if (!(!this.ttoken || !this.ttoken.isValid || !this.utoken || !this.utoken.isValid)) return [3
            /*break*/
            , 2];
            Utils_1.xalTrace(Utils_1.TraceLevel.Information, "Calling GetSisuTokens after handling Sisu response. Ttoken validity: " + (this.ttoken ? this.ttoken.isValid : false) + ". Utoken is valid: " + (this.utoken ? this.utoken.isValid : false) + ".");
            return [4
            /*yield*/
            , this.getSisuTokens()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];

          case 2:
            // Success
            return [4
            /*yield*/
            , this.refreshXtoken()];

          case 3:
            // Success
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.loadTitleNsal = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operationResult;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.step.advance(Step.LoadTitleNsal);
            Utils_1.assert(!!this.xtoken && this.xtoken.isValid);
            return [4
            /*yield*/
            , this.tokenStackComponents.nsal.loadTitleNsal(this.tokenStackComponents.config, this.tokenStackComponents.xboxCache.deviceIdentity, this.xtoken.tokenData, this.httpClient)];

          case 1:
            _a.sent();

            Utils_1.assert(this.step.currentStep === Step.LoadTitleNsal);
            this.step.advance(Step.Done);
            operationResult = {
              xtoken: this.xtoken,
              url: this.sisuUrl,
              sisuSessionId: this.sisuSessionId
            };
            this.succeed(operationResult);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetXtoken.prototype.restoreRehydrationParams = function () {
    Utils_1.assert(!!this.rehydrationParams);
    this.sisuSessionId = this.rehydrationParams.get("sisuSessionId");
    this.sisuClusterAffinity = this.rehydrationParams.get("sisuClusterAffinity");
  };

  return GetXtoken;
}(OperationBase_1.OperationBase);

exports.GetXtoken = GetXtoken;